import { connect } from 'react-redux'

import { setSearchTerm } from '../redux/modules/search/actions'

import ManageBookingDashboard from '../components/ManageBookingDashboard'

const mapStateToProps = (state) => ({
  activeFilterScreen: state.search.activeFilterScreen,
  bootstrapped: state.bootstrap.bootstrapped,
  networkError: state.bootstrap.networkError,
  downloadAllKeyinstructionsLink: state.search.downloadAllKeyInstructionsLink,
  manageGuestDetailsLink: state.search.manageGuestDetailsLink,
  pricesForBookedAccommodations: state.search.prices_for_booked_accommodations
})

const actionCreators = { setSearchTerm }

export default connect(mapStateToProps, actionCreators)(ManageBookingDashboard)



// WEBPACK FOOTER //
// ./src/containers/ManageBookingDashboard.js